import { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';

import { AppDispatch } from '../../store/store';

import { socketClient } from '../socketClient';

import { subscribeWhenConnected } from '../utils/subscribeWhenConnected';

import {
    clearRealtimeState,
    setRealtimeState,
} from '../../store/slices/purchase-dte/purchaseDteRealtimeSlice';

import { PurchaseDteRealtimeMessage } from '../../types/websocket/PurchaseDteRealtimeMessage';
import { updatePurchaseStatus } from '../../store/slices/purchases/basePurchaseSlice';
import { showModal } from '../../store/slices/modals/modalsSlice';

interface Props {
    enabled: boolean;
}

export const usePurchasesDteSubscription = ({
    enabled,
}: Props) => {

    const dispatch: AppDispatch = useDispatch();

    const subscribedRef = useRef(false);

    const subscriptionRef = useRef<any>(null);

    const timeoutRef = useRef<any>(null);

    useEffect(() => {

        if (!enabled) {
            return;
        }

        if (subscribedRef.current) {
            return;
        }

        subscribeWhenConnected(() => {

            if (subscribedRef.current) {
                return;
            }

            subscribedRef.current = true;

            subscriptionRef.current = socketClient.subscribe(

                '/topic/purchases/dte-status',

                (message) => {

                    if (!message.body) {
                        return;
                    }

                    try {

                        const payload: PurchaseDteRealtimeMessage =
                            JSON.parse(message.body);

                        console.log(
                            '📡 PURCHASE DTE realtime:',
                            payload
                        );

                        dispatch(
                            setRealtimeState(payload)
                        );

                        if (payload.status === 'ACCEPTED') {
                            dispatch(updatePurchaseStatus({ id: payload.purchaseId, status: 'DTE_PROCESSED', hasDteError: false }));
                        }

                        if (payload.status === 'DTE_PENDING') {
                            dispatch(updatePurchaseStatus({ id: payload.purchaseId, status: 'DTE_PENDING', hasDteError: false }));
                            dispatch(showModal({
                                modalType: 'warning',
                                modalProps: {
                                    title: payload.title || 'Documento en contingencia',
                                    message: payload.message,
                                },
                            }));
                        }

                        if (payload.status === 'REJECTED') {
                            dispatch(updatePurchaseStatus({ id: payload.purchaseId, status: 'DTE_REJECTED', hasDteError: true }));
                            const observations = payload.observations?.length
                                ? `\n\nObservaciones:\n${payload.observations.join('\n')}`
                                : '';
                            dispatch(showModal({
                                modalType: 'error',
                                modalProps: {
                                    title: payload.title || 'Sujeto excluido rechazado por Hacienda',
                                    message: `${payload.code ? `[${payload.code}] ` : ''}${payload.message}${observations}\n\nPuede consultar y descargar la respuesta completa desde el historial de compras.`,
                                },
                            }));
                        }

                        if (
                            payload.status === 'ACCEPTED' ||
                            payload.status === 'REJECTED' ||
                            payload.status === 'SIN_EMISION_DTE' ||
                            payload.status === 'DTE_PENDING'
                        ) {

                            timeoutRef.current = setTimeout(() => {

                                dispatch(
                                    clearRealtimeState()
                                );

                            }, 4000);
                        }

                    } catch (error) {

                        console.error(
                            '❌ Error purchase realtime DTE:',
                            error
                        );
                    }
                }
            );

            console.log(
                '✅ Purchase DTE subscription registrada'
            );
        });

        return () => {

            subscriptionRef.current?.unsubscribe();

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            subscribedRef.current = false;

            console.log(
                '🛑 Purchase DTE subscription removida'
            );
        };

    }, [enabled]);
};
